// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.target ::ng-deep .btn-optional {
  border-start-start-radius: unset !important;
  border-end-start-radius: unset !important;
}
.target ::ng-deep .ng-select.ng-select-single .ng-select-container {
  border-start-end-radius: 0px !important;
  border-end-end-radius: 0px !important;
  border-color: #DDE0E8 !important; /* Slightly darker than default #EBEDF2 */
}

.select-add-btn {
  margin-top: auto;
  margin-bottom: 13px;
}

.select-add-btn-with-error {
  margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/select-or-add/select-or-add.component.scss"],"names":[],"mappings":"AACI;EACI,2CAAA;EACA,yCAAA;AAAR;AAGI;EACI,uCAAA;EACA,qCAAA;EACA,gCAAA,EAAA,yCAAA;AADR;;AAKA;EACI,gBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,mBAAA;AAFJ","sourcesContent":[".target {\n    ::ng-deep .btn-optional {\n        border-start-start-radius: unset !important;\n        border-end-start-radius: unset !important;\n    }\n\n    ::ng-deep .ng-select.ng-select-single .ng-select-container {\n        border-start-end-radius: 0px !important;\n        border-end-end-radius: 0px !important;\n        border-color: #DDE0E8 !important; /* Slightly darker than default #EBEDF2 */\n    }\n}\n\n.select-add-btn {\n    margin-top: auto;\n    margin-bottom: 13px;\n}\n\n.select-add-btn-with-error {\n    margin-bottom: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
